import { getCardsValues, getCardsColors } from '@/helpers/constants'

function getAllCards() {
  let res = getCardsColors().map(color => getCardsValues().map(cardValue => `${cardValue}${color}`))
  res = res.flat()
  return res
}

function getSortedCardsIds() {
  let res = getCardsValues().map(color => getCardsColors().map(cardValue => `${color}${cardValue}`))
  res = res.flat()
  return res
}

const getCardsFromStr = str => {
  const res = (str || '').match(/.{1,2}(?=(.{2})+(?!.))|.{1,2}$/g)
  return res || []
}

function getCards(str) {
  let res = getCardsFromStr(str)
  const allCards = getAllCards()
  res = (res || []).map(id => allCards.find(c => c === id))
  return res
}

const orderCards = cards => {
  const sortedCardsIds = getSortedCardsIds()
  cards = JSON.parse(JSON.stringify(cards))
  cards.sort((a, b) => {
    if (sortedCardsIds.indexOf(a) > sortedCardsIds.indexOf(b)) {
      return 1
    }
    return -1
  })
  return cards
}

function getSortedBoard(board) {
  let flop = board.slice(0, 6)
  const rest = board.slice(6)

  flop = getCardsFromStr(flop)
  flop = orderCards(flop)
  flop = flop.join('')

  const res = `${flop}${rest}`

  return res
}

const getVisibleCards = street =>
  street === 'preflop' ? 0 : street === 'flop' ? 3 : street === 'turn' ? 4 : 5
const getVisibleBoard = street =>
  street === 'preflop' ? 0 : street === 'flop' ? 6 : street === 'turn' ? 8 : 10

function getValidBoard(board) {
  const cards = getCardsFromStr(board)
  let res = []
  let canContine = true
  cards.forEach(card => {
    if (canContine && !card.includes('E')) {
      res.push(card)
    } else {
      canContine = false
    }
  })
  if (res.length > 2) {
    res = res.join('')
  } else {
    res = ''
  }
  return res
}

const getCardsByStreet = (paramsBoard, street) => {
  if (street === 'preflop') {
    paramsBoard = ''
  } else if (street === 'flop') {
    paramsBoard = paramsBoard.slice(0, 6)
  } else if (street === 'turn') {
    paramsBoard = paramsBoard.slice(6, 8)
  } else if (street === 'river') {
    paramsBoard = paramsBoard.slice(8, 10)
  }
  return paramsBoard
}

const getCardsTillStreet = (paramsBoard, street) => {
  if (street === 'preflop') {
    paramsBoard = ''
  } else if (street === 'flop') {
    paramsBoard = paramsBoard.slice(0, 6)
  } else if (street === 'turn') {
    paramsBoard = paramsBoard.slice(0, 8)
  } else if (street === 'river') {
    paramsBoard = paramsBoard.slice(0, 10)
  }
  return paramsBoard
}

function getStreetIdx(street) {
  const streets = { preflop: 0, flop: 1, turn: 2, river: 3 }
  return streets[street?.toLowerCase()] || 0
}

function getStreetsByBoard(board) {
  const flop = board?.length >= 6 ? 'flop' : null
  const turn = board?.length >= 8 ? 'turn' : null
  const river = board?.length === 10 ? 'river' : null
  const res = ['preflop', flop, turn, river].filter(i => i)
  return res
}
function getStreetByBoard(board) {
  switch (board.length) {
    case 0:
      return 'preflop'
    case 6:
      return 'flop'
    case 8:
      return 'turn'
    case 10:
      return 'river'
    default:
      return null
  }
}

function getFullBoardByStreet(board, street) {
  const visibleCards = getVisibleCards(street)
  let cards = [...getCardsFromStr(board), 'Ee', 'Ee', 'Ee', 'Ee', 'Ee'].slice(0, visibleCards)
  cards = cards.join('')
  return cards
}

function getCardsByStreetArr(board, street) {
  const visibleCards = getVisibleCards(street)
  const cards = [...getCardsFromStr(board), 'Ee', 'Ee', 'Ee', 'Ee', 'Ee'].slice(0, visibleCards)
  return cards
}

const getCardRows = () => [
  ['As', 'Ks', 'Qs', 'Js', 'Ts', '9s', '8s', '7s', '6s', '5s', '4s', '3s', '2s'],
  ['Ah', 'Kh', 'Qh', 'Jh', 'Th', '9h', '8h', '7h', '6h', '5h', '4h', '3h', '2h'],
  ['Ad', 'Kd', 'Qd', 'Jd', 'Td', '9d', '8d', '7d', '6d', '5d', '4d', '3d', '2d'],
  ['Ac', 'Kc', 'Qc', 'Jc', 'Tc', '9c', '8c', '7c', '6c', '5c', '4c', '3c', '2c'],
]

const getEmptyCard = (i = 0) => ({ id: `E${i}` })
const getEmptyCards = length => [...new Array(length).keys()].map(i => getEmptyCard(i))

function getCardNextFromGrid({ card, skipCards, move }) {
  let res = card
  const coordinates = { y: 0, x: 0 }
  const cardRows = getCardRows()

  let y = cardRows.findIndex(row => row.includes(card))
  const xRow = cardRows[y]
  let x = xRow.findIndex(cc => cc === card)
  // console.log(y, x, card, this.cardRows)

  const yMove = move === 'down' ? 1 : move === 'up' ? -1 : 0
  const xMove = move === 'right' ? 1 : move === 'left' ? -1 : 0
  const yl = cardRows.length - 1
  const xl = xRow.length - 1

  const yNext = y + yMove
  const xNext = x + xMove
  y = yNext > yl ? 0 : yNext < 0 ? yl : yNext
  x = xNext > xl ? 0 : xNext < 0 ? xl : xNext

  // console.log(yNext, xNext)

  coordinates.x = x
  coordinates.y = y

  res = cardRows[y][x]
  if (skipCards.includes(res)) {
    return getCardNextFromGrid({ card: res, skipCards, move })
  }
  return res
}

function replaceLastCardFromGrid({ cards, skipCards, move }) {
  const selectedCards = JSON.parse(JSON.stringify(cards)).reverse()
  let crdIdx = selectedCards.findIndex(i => !i.includes('E'))
  crdIdx = crdIdx === -1 ? 0 : crdIdx

  let card = selectedCards[crdIdx] || 'As'
  card = getCardNextFromGrid({ card, skipCards, move })

  selectedCards[crdIdx] = card
  const res = JSON.parse(JSON.stringify(selectedCards)).reverse()
  return res
}

export {
  getCardsValues,
  getCardsColors,
  getAllCards,
  orderCards,
  getCardsFromStr,
  getCards,
  getVisibleCards,
  getVisibleBoard,
  getCardsByStreet,
  getCardsTillStreet,
  getCardRows,
  getStreetIdx,
  getEmptyCard,
  getEmptyCards,
  getSortedCardsIds,
  getSortedBoard,
  getCardsByStreetArr,
  getFullBoardByStreet,
  getStreetsByBoard,
  getStreetByBoard,
  getCardNextFromGrid,
  replaceLastCardFromGrid,
  getValidBoard,
}
